import { IDeletedParam, IRequestParams } from "./page";
import { IIdNameDateTime } from "./id-name";
import { EnterpriseConsoleUserPermission, IInvitation } from "./invitation";

export interface IEnterpriseUser extends IIdNameDateTime<string> {
    email: string;
    permission: EnterpriseConsoleUserPermission;
    isActivated: boolean;
    isAdmin: boolean;
    invitation?: IInvitation;
}

export enum IEnterpriseUserSortField {
    Id = 'id',
    Email = 'email',
    Name = 'name',
    InvitedDate = 'sentDateSentDate'
}

export interface IEnterpriseUserRequestParams extends
    IRequestParams<IEnterpriseUserSortField>,
    IDeletedParam {

    fields?: (keyof IEnterpriseUser)[];
}

export type EnterpriseUserUpdateRequest = Pick<IEnterpriseUser, 'isAdmin'> & Partial<Pick<IEnterpriseUser, 'permission'>>;
